export const FRONT_LOADING_PATHS = {
  ASSOCIATE_ID: 'associate-id',
  CONFIRMATION: 'confirmation',
  CREATE_ORDER: 'create-order',
  DELIVERY_LIST: 'delivery-list',
  DELIVERY_OPTIONS: 'delivery-options',
  DELIVERY_PROVIDER: 'delivery-provider',
  ENTER_SCAN_CODES: 'enter-scan-codes',
  FRONT_LOADING: 'front-loading',
  GUIDED_LOADING_ORDER: 'guided-loading-order',
  HANDED_OFF_CONFIRM: 'handed-off-confirm',
  HANDED_OFF_REASON: 'handed-off-reason',
  HELP_CENTER: 'help-center',
  LOAD_CONFIRMATION: 'load-confirmation',
  LOADING_ORDER: 'loading-order',
  PROCESSING_ORDER: 'processing-order',
  RECLAIM: 'reclaim',
  RESET_SPACE: 'reclaim/space',
  SIZE_SELECTOR: 'size-selector',
  WELCOME: 'welcome',
};

export const FRONT_LOADING_ROUTES = {
  CONFIRMATION: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.CONFIRMATION}`,
  CREATE_ORDER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.CREATE_ORDER}`,
  DELIVERY_LIST: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.DELIVERY_LIST}`,
  DELIVERY_OPTIONS: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.DELIVERY_OPTIONS}`,
  DELIVERY_PROVIDER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.DELIVERY_PROVIDER}`,
  ENTER_SCAN_CODES: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.ENTER_SCAN_CODES}`,
  GUIDED_LOADING_ORDER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.GUIDED_LOADING_ORDER}`,
  HANDED_OFF_CONFIRM: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.HANDED_OFF_CONFIRM}`,
  HANDED_OFF_REASON: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.HANDED_OFF_REASON}`,
  HELP_CENTER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.HELP_CENTER}`,
  HOME: `/${FRONT_LOADING_PATHS.FRONT_LOADING}`,
  LOAD_CONFIRMATION: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.LOAD_CONFIRMATION}`,
  LOADING_ORDER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.LOADING_ORDER}`,
  PROCESSING_ORDER: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.PROCESSING_ORDER}`,
  RECLAIM: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.RECLAIM}`,
  RESET_SPACE: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.RESET_SPACE}`,
  SIZE_SELECTOR: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.SIZE_SELECTOR}`,
  WELCOME: `/${FRONT_LOADING_PATHS.FRONT_LOADING}/${FRONT_LOADING_PATHS.WELCOME}`,
} as const;
